<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.CompanyNo" placeholder="公司编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.UserNo" placeholder="用户编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.Nickname" placeholder="微信名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select v-model="filters.Subscribe" placeholder="全部状态" style="width: 130px;">
						<el-option key="-1" label="全部状态" value="-1"></el-option>
						<el-option key="1" label="已订阅" value="1"></el-option>
						<el-option key="0" label="未订阅" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="filters.isServiceOrProgram" placeholder="用户来源" style="width: 130px;">
						<el-option key="-1" label="全部用户" value="-1"></el-option>
						<el-option key="1" label="服务号" value="1"></el-option>
						<el-option key="2" label="小程序" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="GetPage" :loading="listLoading" style="width:80px"> 查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" fit stripe highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column type="index" fixed="left" width="60" label="行号" align="center"></el-table-column>
			<el-table-column prop="companyNo" label="名称" min-width="100" align="center"></el-table-column>
			<el-table-column prop="nickname" label="名称" min-width="150" align="center"></el-table-column>
			<el-table-column prop="userNo" label="绑定用户编号" min-width="150" align="center"></el-table-column>
			<el-table-column prop="headimgUrl" label="头像" min-width="150" align="center">
				<template slot-scope="scope">
					<img :src="scope.row.headimgUrl" alt="" style="width: 50px;height: 50px">
				</template>
			</el-table-column>
			<el-table-column prop="openId" label="openId" min-width="300" align="center"></el-table-column>
			<el-table-column prop="country" label="国家" min-width="100" align="center"></el-table-column>
			<el-table-column prop="province" label="省" min-width="100" align="center"></el-table-column>
			<el-table-column prop="city" label="市" min-width="100" align="center"></el-table-column>
			<el-table-column prop="createTime" label="创建时间" min-width="200" align="center" :formatter="dateFormat"></el-table-column>
			<el-table-column prop="subscribeTime" label="关注时间" min-width="200" align="center" :formatter="dateFormat"></el-table-column>
			<el-table-column fixed="right" label="操作" align="center" width="170">
				<template slot-scope="scope">
					<el-button size="small" @click="handlebinding(scope.$index, scope.row)">绑定</el-button>
					<el-button type="danger" size="small" @click="handlebindingClose(scope.$index, scope.row)">取消绑定</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--分页栏-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-size="pagesize" :page-sizes="[10,20,30]" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<!--新增 编辑界面-->
		<el-dialog title="提示" :visible.sync="dataFormVisible" :close-on-click-modal="false" width="40%" center @close="clearValidate('dataForm')">
			<el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
				<el-form-item label="用户编号" prop="UserNo">
					<el-select v-model="dataForm.UserNo" filterable default-first-option placeholder="请选择用户" style="width: 100%;">
						<el-option v-for="item in UserList" :key="item.userNo" :label="item.userName" :value="item.userNo"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('dataForm')">绑定</el-button>
					<el-button @click.native="clearValidate('dataForm')">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</section>
</template>

<script>
	import { SetBinding, GetPage } from '../../api/WechatUser';
	import { GetList } from '../../api/User';
	import { hashcode } from '../../utils/validate';
	export default {
		data() {
			return {
				filters: {
					UserNo: '',
					Nickname: '',
					Subscribe: "-1",
					isServiceOrProgram: "-1"
				},
				rules: {
					UserNo: [{
						required: true,
						message: '请选择用户',
						trigger: 'change'
					}],
				},
				datalist: [],
				dataForm: {},
				UserList: {},
				total: 0, //总页数
				page: 1, //第几页
				pagesize: 10, //每业显示条数
				listLoading: false, //列表加载动画
				dataLoading: false, //提交动画				
				dataFormVisible: false, //编辑界面是否显示
				edithashcode: '',
				dataFormRules: {
					UserNo: [{
						required: true,
						message: '请输入账号',
						trigger: 'change'
					}],
				},
			}
		},
		methods: {
			//点击页数跳转
			handleCurrentChange(val) {
				this.page = val;
				this.GetPage();
			},
			//每页条数
			handleSizeChange(val) {
				this.pagesize = val;
				this.GetPage();
			},
			//获取数据列表
			GetPage() {
				let para = {
					page: this.page,
					row: this.pagesize
				};
				//添加查询参数
				for(let x in this.filters) {
					if(this.filters[x]) para[x] = this.filters[x];
				};
				this.listLoading = true;
				GetPage(para).then(response => {
					this.total = response.data.total;
					this.datalist = response.data.rows;
					this.listLoading = false;

				}).catch((res) => {
					this.listLoading = false;
				})
			},
			//显示绑定界面
			handlebinding: function(index, row) {
				this.dataFormVisible = true;
				this.dataForm = Object.assign({}, row);
				this.edithashcode = hashcode(this.dataForm);
			},
			getinitdata: function() {
				GetList().then(response => {
					this.UserList = response.data;
				});
			},
			submitForm(formName) {
				this.$refs.dataForm.validate((valid) => {
					if(valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.dataLoading = true;
							//加载参数
							let para = Object.assign({}, this.dataForm);

							SetBinding(para).then((res) => {

								this.$message({
									message: res.msg,
									type: 'success'
								});

								this.dataFormVisible = false;
								this.GetPage();
								this.dataLoading = false;
							}).catch((res) => {
								this.dataLoading = false;
							})
						});
					}
				});
			},
			clearValidate(manageForm) {
				this.dataFormVisible = false;
				this.$refs[manageForm].resetFields();
			},
			handlebindingClose: function(index, row) {
				this.$confirm('确认取消绑定?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					let para = {
						WechatId: row.wechatId,
						UserNo:""
					};
					SetBinding(para).then((res) => {
						this.$message({
							message: '取消绑定成功',
							type: 'success'
						});
						this.listLoading = false;
						this.GetPage();
					}).catch((res) => {
						this.listLoading = false;
					})
				}).catch(() => {
					
				});

			},
		},
		mounted() {
			this.getinitdata();
			this.GetPage();
		}
	}
</script>

<style>
.el-table td
{
	padding: 5px 0 0 0;
}
</style>